<template>
  <div class="why-bimlib py-12">
    <bimContainer>
      <bim-text type="h4" bold class="why-bimlib__title mx-auto">{{ $t("Тысячи профессиональных проектировщиков выбирают плагин BIMLIB") }}</bim-text>

      <div class="block-info d-block d-xl-flex justify-center w-100">
        <div class="block-info__wrapper block-info__wrapper--big mr-auto mr-xl-10">
          <div class="block-info__item block-info__item--big">
            <img src="/dist/assets/front_white/img/landing_plugin/BIMLIB_plugin01.png" class="image" width=404 @click="openImagePopup('/dist/assets/front_white/img/landing_plugin/BIMLIB_plugin01.png')" />
            <bim-text class="title mt-10 mb-6" type=h5 bold>{{ $t("Универсальный поиск") }}</bim-text>
            <bim-text class="text" type=main>{{ $t("Разложенные по категориям файлы готовы к загрузке из интерфейса плагина. Без рекламы и SMS.") }}</bim-text>
          </div>
        </div>

        <div class="block-info__wrapper block-info__wrapper--small">
          <div class="block-info__item block-info__item--small mr-10 mb-10">
            <div class="image__wrapper w-100">
              <img src="/dist/assets/front_white/img/landing_plugin/icon-1.svg" alt="" />
            </div>
            <bim-text class="text" type=medium bold>{{ $t("Не надо точно знать модель изделия. Ключевого слова достаточно для поиска.") }}</bim-text>
          </div>

          <div class="block-info__item block-info__item--small mb-10">
            <div class="image__wrapper w-100">
              <img src="/dist/assets/front_white/img/landing_plugin/icon-2.svg" alt="" />
            </div>
            <bim-text class="text" type=medium bold>{{ $t("Встроенные калькуляторы от производителей для необходимых расчетов - без ошибок и быстро") }}</bim-text>
          </div>

          <div class="block-info__item block-info__item--small mr-10">
            <div class="image__wrapper w-100">
              <img src="/dist/assets/front_white/img/landing_plugin/icon-3.svg" alt="" />
            </div>
            <bim-text class="text" type=medium bold>{{ $t("Режим Drag-n-Drop: добавление модели в проект простым перетаскиванием мышью") }}</bim-text>
          </div>
          
          <div class="block-info__item block-info__item--small">
            <div class="image__wrapper w-100">
              <img src="/dist/assets/front_white/img/landing_plugin/icon-4.svg" alt="" />
            </div>
            <bim-text class="text" type=medium bold>{{ $t("Сохранение файлов моделей форматов DWG, DXF для последующего импорта") }}</bim-text>
          </div>
        </div>
      </div>

      <bim-text type="accent" bold class="why-bimlib__desc">{{ $t("С каждым обновлением не только ускоряется работа и повышается безотказность плагина, но еще и вводятся новые функции.") }}</bim-text>
      <bimPopup
        closeOnWrapper
        v-model="popup.show"
        title=""
        width="90vw"
      >
        <img alt="" :src="popup.data" />
      </bimPopup>
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimPopup from "@bimlib/components/bimPopup"
import bimCol from "@bimlib/components/bimCol"
export default {
  name: "",
  components: {
    bimContainer,
    bimPopup,
    bimCol,
  },
  data() {
    return {
      popup: {
        data: "",
        show: false,
      }
    }
  },
  methods: {
    openImagePopup(img) {
      this.popup.data = img;
      this.popup.show = true;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";

.why-bimlib {
  background-color: $white-color;

  .why-bimlib__title,
  .why-bimlib__desc {
    text-align: center;
    max-width: 972px;
    margin: auto;
  }

  .why-bimlib__desc {
    @media screen and (max-width: $breakpoint-sm) {
      font-size: 18px;
    }
  }
  
  .why-bimlib__title {
    @media screen and (max-width: $breakpoint-sm) {
      ::v-deep .text__inner {
        font-size: 24px;
      }
    }
  }
}

.block-info {
  margin-top: 64px;

  .block-info__item {
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    background-color: $white-color;
      box-shadow: 0px 0px 10px 1px $white-color-300;
  }
  
  .block-info__item--small {
    width: 207px;
    height: 207px;
    padding: 24px;
    padding-bottom: 0;
    justify-content: flex-start;

    .text {
      padding-top: 14px;
      line-height: 1.36;
    }
  }

  .block-info__item--big {
    width: 684px;
    height: 446px;

    @media screen and (max-width: $breakpoint-md) {
      width: 100%;
    }

    .image {
      object-fit: cover;
      cursor: pointer;
    }

    .title,
    .text {
      text-align: center;
    }

    .title {
      line-height: 1.13;
      @media screen and (max-width: $breakpoint-sm) {
        ::v-deep .text__inner {
          font-size: 18px;
        }
      }
    }

    .text {
      width: 80%;
      line-height: 1.5;
      letter-spacing: 0.2px;

      @media screen and (max-width: $breakpoint-sm) {
        font-size: 14px;
      }
    }
  }

  .block {
    width: 100%;
    height: 100%;
    background-color: $white-color;
    border-radius: 5px;
  }

  .block-info__wrapper {
    margin-bottom: 42px;

    @media screen and (max-width: $breakpoint-xl) {
      margin-right: auto;
      margin-left: auto;
    }
  }

  .block-info__wrapper--small {
    display: flex;
    flex-wrap: wrap;
    max-width: calc(207px * 2 + 32px);

    @media screen and (max-width: $breakpoint-sm) {
      justify-content: center;

      .block-info__item {
        margin: 0 0 32px !important;
      }
    }
  }

  .block-info__wrapper--big {
    max-width: 684px;
  }
}
</style>
